import { Link } from 'react-router-dom';
import { getAllArticles } from '../data/articles';

function Home() {
  const allArticles = getAllArticles();
  const latestArticle = allArticles[0]; // Get the most recent article
  const recentArticles = allArticles.slice(0, 3); // Get up to 3 most recent articles

  return (
    <div className="App">
      <div className="min-h-screen bg-cover bg-center bg-no-repeat bg-scroll" style={{backgroundImage: "url('/background.png')"}}>
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16 min-h-screen">
            {/* Left Content - Desktop */}
            <div className="hidden lg:flex flex-1 flex-col justify-center text-left pl-12 space-y-12">
              
              {/* Hero Section */}
              <div className="space-y-8">
                <div className="space-y-6">
                  <h1 className="text-7xl xl:text-7xl font-bold text-orange-500 leading-tight">
                    Welcome To<br /> 
                    <span className="text-6xl xl:text-6xl text-gray-800">
                      Fatak App
                    </span>
                  </h1>
                  <p className="text-3xl xl:text-4xl text-gray-700 font-medium">
                    Don't wait, just navigate
                  </p>
                </div>
                
                {/* App Store Buttons */}
                <div className="flex justify-start gap-8">
                  <div className="group">
                    <img 
                      src='/appstore.png' 
                      alt="App Store" 
                      className="h-20 xl:h-22 w-auto group-hover:scale-110 transition-all duration-300 drop-shadow-lg"
                    />
                  </div>
                  <div className="group">
                    <img 
                      src='/playstore.png' 
                      alt="Play Store" 
                      className="h-20 xl:h-22 w-auto group-hover:scale-110 transition-all duration-300 drop-shadow-lg"
                    />
                  </div>
                </div>
              </div>

              {/* Contact Section */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-8 shadow-xl">
                <div className="text-left mb-8">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-4 h-4 bg-green-500 rounded-full animate-pulse"></div>
                    <h3 className="text-3xl font-bold text-gray-800">
                      Get in Touch
                    </h3>
                  </div>
                  <p className="text-base text-gray-600 font-medium">
                    Available 24/7 for your convenience
                  </p>
                </div>
                
                <div className="grid grid-cols-3 gap-6">
                  {/* Business Contact */}
                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl border-2 border-orange-200 p-4 hover:from-orange-100 hover:to-orange-200 hover:border-orange-300 transition-all duration-300 hover:shadow-lg group">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-sm text-orange-700 font-semibold uppercase tracking-wide">Business</p>
                      <p className="text-sm text-orange-900 font-bold">
                        +91 7888626805
                      </p>
                    </div>
                  </div>

                  {/* Technical Contact */}
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border-2 border-blue-200 p-4 hover:from-blue-100 hover:to-blue-200 hover:border-blue-300 transition-all duration-300 hover:shadow-lg group">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-sm text-blue-700 font-semibold uppercase tracking-wide">Technical</p>
                      <p className="text-sm text-blue-900 font-bold">
                        +91 8559060991
                      </p>
                    </div>
                  </div>

                  {/* Operations Contact */}
                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl border-2 border-purple-200 p-4 hover:from-purple-100 hover:to-purple-200 hover:border-purple-300 transition-all duration-300 hover:shadow-lg group">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-sm text-purple-700 font-semibold uppercase tracking-wide">Operations</p>
                      <p className="text-sm text-purple-900 font-bold">
                        +91 7355357459
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Layout */}
            <div className="lg:hidden flex flex-col items-center text-center space-y-8 w-full">
              {/* Mobile Hero Section */}
              <div className="space-y-6">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-orange-500 leading-tight">
                  Welcome To<br /> 
                  <span className="text-3xl sm:text-4xl md:text-5xl text-gray-800">
                    Fatak App
                  </span>
                </h1>
                <p className="text-lg sm:text-xl md:text-2xl text-gray-700 font-medium">
                  Don't wait, just navigate
                </p>
              </div>
              
              {/* Mobile App Store Buttons */}
              <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-8">
                <div className="group">
                  <img 
                    src='/appstore.png' 
                    alt="App Store" 
                    className="h-14 sm:h-16 md:h-18 w-auto group-hover:scale-110 transition-all duration-300 drop-shadow-lg"
                  />
                </div>
                <div className="group">
                  <img 
                    src='/playstore.png' 
                    alt="Play Store" 
                    className="h-14 sm:h-16 md:h-18 w-auto group-hover:scale-110 transition-all duration-300 drop-shadow-lg"
                  />
                </div>
              </div>

              {/* Mobile Phone Image */}
              <div className="flex justify-center items-center">
                <img 
                  src='/phone.png' 
                  alt="Phone" 
                  className="h-64 sm:h-80 md:h-96 w-auto max-w-full hover:scale-102 transition-transform duration-300"
                />
              </div>

              {/* Mobile Contact Section */}
              <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-6 shadow-xl w-full">
                <div className="text-center mb-6">
                  <div className="flex items-center justify-center gap-3 mb-3">
                    <div className="w-4 h-4 bg-green-500 rounded-full animate-pulse"></div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-800">
                      Get in Touch
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 font-medium">
                    Available 24/7 for your convenience
                  </p>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Business Contact */}
                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl border-2 border-orange-200 p-4 hover:from-orange-100 hover:to-orange-200 hover:border-orange-300 transition-all duration-300 hover:shadow-lg group">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-xs sm:text-sm text-orange-700 font-semibold uppercase tracking-wide">Business</p>
                      <p className="text-xs sm:text-sm text-orange-900 font-bold">
                        +91 7888626805
                      </p>
                    </div>
                  </div>

                  {/* Technical Contact */}
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border-2 border-blue-200 p-4 hover:from-blue-100 hover:to-blue-200 hover:border-blue-300 transition-all duration-300 hover:shadow-lg group">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-xs sm:text-sm text-blue-700 font-semibold uppercase tracking-wide">Technical</p>
                      <p className="text-xs sm:text-sm text-blue-900 font-bold">
                        +91 8559060991
                      </p>
                    </div>
                  </div>

                  {/* Operations Contact */}
                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl border-2 border-purple-200 p-4 hover:from-purple-100 hover:to-purple-200 hover:border-purple-300 transition-all duration-300 hover:shadow-lg group sm:col-span-2">
                    <div className="flex flex-col items-center text-center space-y-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <p className="text-xs sm:text-sm text-purple-700 font-semibold uppercase tracking-wide">Operations</p>
                      <p className="text-xs sm:text-sm text-purple-900 font-bold">
                        +91 7355357459
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Desktop Right Content - Phone Image */}
            <div className="hidden lg:flex flex-1 justify-center items-center">
              <img 
                src='/phone.png' 
                alt="Phone" 
                className="h-[500px] xl:h-[600px] w-auto max-w-full hover:scale-102 transition-transform duration-300"
              />
            </div>
          </div>
          
          {/* Latest News Section */}
          {recentArticles.length > 0 && (
            <div className="max-w-4xl mx-auto mt-12 sm:mt-16 lg:mt-24 mb-12 sm:mb-16 px-2">
              <div className="text-center mb-6 sm:mb-8">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-2">
                  Latest News & Updates
                </h2>
                <p className="text-sm sm:text-base text-gray-600">
                  Stay informed about the latest from Fatak App
                </p>
              </div>
              
              <div className="space-y-6 sm:space-y-8">
                {recentArticles.map((article, index) => (
                  <div 
                    key={article.id}
                    className="bg-white/95 backdrop-blur-sm rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden hover:shadow-3xl transition-shadow"
                  >
                    <div className="mb-4 sm:mb-6">
                      <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-3">
                        <span className="px-3 sm:px-4 py-1 bg-orange-500 text-white text-xs sm:text-sm font-bold rounded-full whitespace-nowrap">
                          {index === 0 ? 'LATEST NEWS' : article.category.toUpperCase()}
                        </span>
                        <span className="text-xs sm:text-sm text-gray-500">{article.location}</span>
                        <span className="text-xs sm:text-sm text-gray-500 hidden sm:inline">•</span>
                        <span className="text-xs sm:text-sm text-gray-500">
                          {new Date(article.date).toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'short', 
                            day: 'numeric' 
                          })}
                        </span>
                      </div>
                      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight mb-3 sm:mb-4">
                        {article.title}
                      </h2>
                    </div>
                    
                    <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6">
                      {article.excerpt}
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                      <Link
                        to={`/news/${article.slug}`}
                        className="inline-block px-5 sm:px-6 py-2.5 sm:py-3 bg-orange-500 text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-orange-600 transition-colors text-center"
                      >
                        Read Full Article →
                      </Link>
                    </div>
                  </div>
                ))}
                
                {allArticles.length > 3 && (
                  <div className="text-center pt-4">
                    <Link
                      to="/news"
                      className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-gray-200 text-gray-800 text-sm sm:text-base font-semibold rounded-lg hover:bg-gray-300 transition-colors"
                    >
                      View All {allArticles.length} Articles →
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;

